import React, { useEffect } from "react";
import "./HomePage.scss";
import AlumniSlider from "../../components/AlumniSlider/AlumniSlider";
import studyimage from '../../assets/images/study center.jpg';
import sportsimage from '../../assets/images/sports.jpg';
import cultureimage from '../../assets/images/culture.jpg';
import labimage from '../../assets/images/lab.jpg';
import labimage1 from '../../assets/images/2-1.jpg';
import labimage2 from '../../assets/images/6-1-1024x338.jpg';
import labimage3 from '../../assets/images/IMG_20180414_105940-1024x768.jpg';
import labimage4 from '../../assets/images/new-clg-pic-Copy-300187189.jpg';
import labimage6 from '../../assets/images/WhatsApp Image 2024-12-26 at 16.jpg';
import labimage5 from '../../assets/images/WhatsApp Image 2024-12-26 at 16.47.24_87315dc3.jpg';
import labimage7 from '../../assets/images/IMG-20241226-WA0018[1].jpg';
import labimage8 from '../../assets/images/WhatsApp Image 2024-12-26 at 17.20.29_9140c887.jpg';
import labimage9 from '../../assets/images/IMG-20241226-WA0019[1].jpg';
import ImageSlider from "../../components/Slider/Slider";
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomePage: React.FC = () => {
  useEffect(() => {
    AOS.init({
        duration: 1000, // Animation duration in milliseconds
        easing: 'ease-in-out', // Easing style
        once: false, // Whether animation should happen only once
        offset: 120, // Offset from the original trigger point in pixels
    });
}, []);
  return (
    <div className="homepage">
      <ImageSlider/>
      {/* Hero Section */}
      <div className="hero-main">
      <header className="hero-section">
        <h1 data-aos="fade-down">S.J.M Government Aided Polytechnic, Birur</h1>
<p data-aos="fade-up">Admissions Open for 2026–27 </p>
        <a href="#explore-course" className="btn-primary" data-aos="zoom-in">
          Explore Courses
        </a>
      </header>
      </div>
    {/* 🔥 Clean Mobile-First Admission Section */}
<section className="admission-banner">

  <div className="header">
    <span className="tag">Admissions Open 2026–27</span>
    <h1>Diploma in EC Engineering</h1>
    <p>S.J.M Govt Aided Polytechnic, Birur</p>
  </div>

  {/* Cards */}
  <div className="cards">

    <div className="card">
      <h3>🎯 Eligibility</h3>
      <ul>
        <li>SSLC → 1st Year</li>
        <li>PUC / ITI → Direct 2nd Year</li>
      </ul>
    </div>

    <div className="card">
      <h3>💰 Fees (Yearly)</h3>
      <ul>
        <li>SC/ST/Cat-1: ₹7,670</li>
        <li>GM/OBC: ₹7,770</li>
      </ul>
    </div>

    <div className="card">
      <h3>🚀 Career Opportunities</h3>
      <ul>
        <li>Govt Jobs (KPSC, Railway, KEB)</li>
        <li>Infosys, Wipro, TATA, Reliance</li>
      </ul>
    </div>

    <div className="card">
      <h3>🎓 Higher Studies</h3>
      <ul>
        <li>Direct 2nd Year Engineering</li>
        <li>B.E, B.Tech, BCA, BBA, B.Sc</li>
      </ul>
    </div>

  </div>

  {/* CTA */}
  <div className="cta">
    <a href="tel:9036447506" className="call-btn">
      📞 Call Now
    </a>
  </div>

  <div className="contact">
    📱 9036447506 | 9008214404 | 9972283180
  </div>

</section>
      {/* <div className="video-banner-section">
      <video className="video-banner" autoPlay muted loop playsInline>
        <source src='/videos/2025-26 admission.mp4' type="video/mp4" />
        Your browser does not support the video tag.
        </video>
      </div> */}
      
      {/* Programs Offered Section */}
      <section className="programs-offered">
        <h2 className="section-title">What We Offer</h2>
        <p className="section-description">
          Explore our state-of-the-art facilities and programs designed to
          support academic and extracurricular growth.
        </p>
        <div className="programs-grid">
          <div className="program-card" data-aos="fade-right">
            <img src={studyimage} alt="Study Center" />
            <h3>Study Centers</h3>
            <p>
              Promoting moral values and providing learning spaces for students
              of all walks of life.
            </p>
          </div>
          <div className="program-card" data-aos="fade-up">
          <img src={sportsimage} alt="Sports" />
            <h3>Sports</h3>
            <p>
              Multi-purpose halls for physical activities and various sports
              events.
            </p>
          </div>
          <div className="program-card" data-aos="fade-left">
            <img src={cultureimage} alt="Cultural Activities" />
            <h3>Cultural Activities</h3>
            <p>
              Encouraging creativity and ensuring the overall well-being of
              students.
            </p>
          </div>
          <div className="program-card" data-aos="fade-up">
            <img src={labimage} alt="Laboratories" />
            <h3>Laboratories</h3>
            <p>
              Fully equipped labs with internet access to support academic
              programs.
            </p>
          </div>
        </div>
      </section>

      {/* Explore Courses Section */}
      <section className="explore-course" id="explore-course">
        <div className="content-container">
          <h2 className="section-title">Explore Our Courses</h2>
          <p className="department-description">
            Our college currently offers a comprehensive program in the{" "}
            <strong>Electronics and Communication Engineering (EC)</strong>{" "}
            department. Dive into the world of innovation, embedded systems, and
            communication technologies.
          </p>
          <div className="btn-container">
            <a href="/ec-course" className="btn-explore">
              Explore EC Department
            </a>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="photo-gallery">
        <h2 className="section-title">Our Campus Life</h2>
        <div className="gallery-grid">
          <img
            src={labimage4}
            alt="Campus 1"
            data-aos="zoom-in"
          />
          <img
            src={labimage1}
            alt="Campus 2"
            data-aos="zoom-in"
          />
          <img
            src={labimage2}
            alt="Campus 3"
            data-aos="zoom-in"
          />
           <img
            src={labimage7}
            alt="Campus 3"
            data-aos="zoom-in"
          />
          <img
            src={labimage8}
            alt="Campus 4"
            data-aos="zoom-in"
          />
          <img
            src={labimage9}
            alt="Campus 4"
            data-aos="zoom-in"
          />
          <img
            src={labimage6}
            alt="Campus 3"
            data-aos="zoom-in"
          />
          <img
            src={labimage3}
            alt="Campus 4"
            data-aos="zoom-in"
          />
          <img
            src={labimage5}
            alt="Campus 4"
            data-aos="zoom-in"
          />
         
        </div>
      </section>

      {/* Alumni Section */}
      {/* <AlumniSlider /> */}
    </div>
  );
};

export default HomePage;
